import React from 'react';
import Page from '../../layout/Page';
import MobileProducts from '../mobile/Products';

const MobileAppPage = () => (
    <Page title='Mobile App' icon='coins'>
        <MobileProducts />
    </Page>
);

export default MobileAppPage;
